import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { usePermissions } from "@poseidon/ui/components";
import { CreateSailorModal } from "./CreateSailorModal";

const fabStyle = {
  position: "absolute",
  top: 80,
  right: 16,
};

export function CreateSailorFab() {
  const [show, setShow] = useState(false);
  // adminCreateSailorAccount requires admin:write, so hide the button from
  // read-only admins rather than letting them hit a permission error.
  const { canWrite } = usePermissions();
  if (!canWrite) {
    return null;
  }
  return (
    <>
      <Fab
        size="small"
        color="primary"
        aria-label="add sailor"
        sx={fabStyle}
        onClick={() => setShow(true)}
      >
        <AddIcon />
      </Fab>
      <CreateSailorModal onClose={() => setShow(false)} open={show} />
    </>
  );
}
